import styled from '@emotion/styled';
import React from 'react';
import { dot1, dot2, dot3 } from './copilotAnimations';

const Pill = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 13px;
  border-radius: 8px;
  background: ${(p) => p.theme.dado.copilot.purpleSurface};
  max-width: 175px;
`;

const Dots = styled('div')`
  display: flex;
  gap: 3px;
  align-items: center;
  flex-shrink: 0;
`;

const Dot = styled('span')<{ phase: 1 | 2 | 3 }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  display: inline-block;
  background: ${(p) => p.theme.dado.copilot.purpleAccent};
  animation: ${(p) => (p.phase === 1 ? dot1 : p.phase === 2 ? dot2 : dot3)} 1.2s
    ease-in-out infinite;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`;

const Label = styled('span')`
  font-size: 13px;
  font-weight: 300;
  color: ${(p) => p.theme.dado.copilot.purpleAccent};
`;

export const ThinkingDots: React.FC<{ label?: string }> = ({ label = 'Thinking...' }) => (
  <Pill role="status" aria-live="polite">
    <Dots aria-hidden="true">
      <Dot phase={1} />
      <Dot phase={2} />
      <Dot phase={3} />
    </Dots>
    <Label>{label}</Label>
  </Pill>
);
